<div class="t-{{activeTheme.theme}} wrapper">
  <div *ngIf="getWorkerInfoWorker().userBackground.safeSrc" class="workerInfoBackgroundFrame">
    <img class="workerInfoBackground"
         [src]="getWorkerInfoWorker().userBackground.safeSrc">
    <!--[@workerState]="getWorkerInfoWorker()._apiData.stateA">-->
  </div>
  <button mat-raised-button class="buttonIcon" (click)="close()">
    <i class="material-icons">close</i>
  </button>
  <div class="workerInfoPortraitCaptionFrame">
    <div class="workerInfoPortraitFrame">
      <img class="workerInfoPortrait" [src]="getWorkerInfoWorker().userImage.safeSrc">
    </div>
    <div class="workerInfoCaptionFrame">
      <p>{{getWorkerInfoWorker()._apiData.name}}</p>
      <button mat-flat-button *ngIf="appService.getInterfaceAttendanceAllowSimpleCiCo()" (click)="toggleCheckin(getWorkerInfoWorker())">
        {{ (getWorkerInfoWorker()._apiData.checkedIn ? "CHECK_OUT" : "CHECK_IN") | translate}}
      </button>
    </div>
  </div>
</div>
